<template>
  <div>
    <div v-if="fixed" class="sl_progress__fixed">
      <v-progress-linear v-if="active" :indeterminate="true" color='success'></v-progress-linear>
    </div>
    <div v-else>
      <v-progress-linear v-if="active" :indeterminate="true" color='success'></v-progress-linear>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Progress',
    props: {
      'fixed': {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        active: false
      }
    },
    computed: {
      ...mapGetters(['progress'])
    },
    watch: {
      progress(value) {
        this.active = true
        Promise.all(value).then(() => {
          this.active = false
        });
      }
    }

  }
</script>
